import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { getApiUrl } from '../config/apiConfig';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Gets the API base URL without trailing slashes to prevent double slash issues
 * @returns The API base URL with any trailing slashes removed
 */
export function getApiBaseUrl(): string {
  return getApiUrl('').replace(/\/+$/, '');
}
